export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /* eslint-disable */

    $(document).ready(function(){


          // This will create a single gallery from all elements that have class "gallery-item"
          $('.popup-gallery').magnificPopup({
            delegate: "a",
            type: 'image',
            image: {
                titleSrc: function(item) {
                    return item.el.attr('title');
                }
            },
            gallery:{
              enabled:true
            }
          });


          $('.slick-testimonials').slick({
            arrows: true,
            dots: false,
            autoplay: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
          });



    });

   	/* eslint-enable */

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/casestudies.js